'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _animateFadeDecorator = require('../animations/animateFadeDecorator');

var _animateFadeDecorator2 = _interopRequireDefault(_animateFadeDecorator);

var _MilanoteLogo = require('../icons/MilanoteLogo');

var _MilanoteLogo2 = _interopRequireDefault(_MilanoteLogo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LogoSpinner = function LogoSpinner(props) {
    return _react2.default.createElement(
        'div',
        { className: 'LogoSpinner' },
        _react2.default.createElement(_MilanoteLogo2.default, props)
    );
};

exports.default = (0, _animateFadeDecorator2.default)()(LogoSpinner);


//////////////////
// WEBPACK FOOTER
// ./src/client/components/loaders/LogoSpinner.js
// module id = 707
// module chunks = 0